import DeliveriesTrackerLogo from "../static/deliveriestracker.png";
import ChargingTrackerLogo from "../static/chargingtracker.png";
import IptvTimeLogo from "../static/iptvtime.png";
import CapasDoDiaLogo from "../static/capasdodia.svg";
import InstaRecipesLogo from "../static/instarecipes.png";

export const APPS = [
  {
    id: "deliveries-tracker",
    title: "Deliveries Tracker",
    icon: DeliveriesTrackerLogo,
    appStoreUrl: "https://apps.apple.com/us/app/deliveries-tracker/id1266864859",
    websiteUrl: "https://www.deliveriestracker.com",
    description:
      "Track your parcels with iCloud sync, timely notifications, iPad support, dark mode, and major carriers like DHL, FedEx, UPS, GLS, TNT, DPD, and USPS.",
    screenshots: [
      require("../static/deliveries-tracker/track.jpg"),
      require("../static/deliveries-tracker/details.jpg"),
      require("../static/deliveries-tracker/map.jpg"),
      require("../static/deliveries-tracker/notifications.jpg"),
      require("../static/deliveries-tracker/dark.jpg"),
      require("../static/deliveries-tracker/widgets.jpg"),
      require("../static/deliveries-tracker/app-intelligence.jpg"),
    ],
  },
  {
    id: "instarecipes-reel2meal",
    title: "InstaRecipes – Reel2Meal",
    icon: InstaRecipesLogo,
    websitePath: "/apps/insta-recipes",
    appStoreUrl:
      "https://apps.apple.com/pt/app/instarecipes-reel2meal/id6746102558",
    privacyPolicyUrl: "/instarecipes/privacy-policy",
    description:
      "Turn Instagram Reels into real recipes in seconds with AI-generated ingredients, clear steps, nutrition information, multilingual support, and a curated recipe explorer.",
    screenshots: [
      require("../static/insta-recipes/home.jpg"),
      require("../static/insta-recipes/player.jpg"),
      require("../static/insta-recipes/details.jpg"),
      require("../static/insta-recipes/nutrition.jpg"),
      require("../static/insta-recipes/explorer.jpg"),
      require("../static/insta-recipes/cart.jpg"),
    ],
  },
  {
    id: "charging-tracker",
    title: "Charging Tracker",
    icon: ChargingTrackerLogo,
    websitePath: "/apps/charging-tracker",
    appStoreUrl:
      "https://apps.apple.com/us/app/etracker-charging-tracker/id1639183407",
    description:
      "Keep track of energy meter readings and costs, then generate custom PDF reports with photos to share, print, or save in Files.",
    screenshots: [
      require("../static/charging-tracker/track.jpg"),
      require("../static/charging-tracker/control.jpg"),
      require("../static/charging-tracker/fuel.jpg"),
      require("../static/charging-tracker/report.jpg"),
      require("../static/charging-tracker/dark.jpg"),
    ],
  },
  {
    id: "iptv-time",
    title: "IPTV Time",
    icon: IptvTimeLogo,
    appStoreUrl: "https://apps.apple.com/us/app/iptv-time/id1434729544",
    websiteUrl: "https://www.iptv-time.com",
    description:
      "Supports .m3u and .m3u8 playlists with HLS, plus iCloud sync, reminder notifications, iPad optimization, and light/dark modes.",
    screenshots: [
      require("../static/iptv/iptv-appstore-01.jpg"),
      require("../static/iptv/iptv-appstore-02.jpg"),
      require("../static/iptv/iptv-appstore-03.jpg"),
      require("../static/iptv/iptv-appstore-04.jpg"),
      require("../static/iptv/iptv-appstore-05.jpg"),
      require("../static/iptv/iptv-stream-quality.jpg"),
      require("../static/iptv/iptv-vlc.jpg"),
    ],
  },
  {
    id: "capas-do-dia",
    title: "Capas do Dia",
    icon: CapasDoDiaLogo,
    websitePath: "/apps/capas-do-dia",
    appStoreUrl: "https://apps.apple.com/us/app/id1496747181",
    description:
      "A free, modern app compatible with new iPhone layouts and with Dark Mode support.",
    screenshots: [
      require("../static/capas-do-dia/capas-01.webp"),
      require("../static/capas-do-dia/capas-02.webp"),
      require("../static/capas-do-dia/capas-03.webp"),
      require("../static/capas-do-dia/capas-04.webp"),
    ],
  },
];
